<script setup lang="ts">
import { computed } from 'vue';
import { LockIcon, ShieldIcon } from '@/shared/ui/icons/';

interface Props {
  icon?: 'lock' | 'shield' | 'none';
}

const props = defineProps<Props>();

const iconComponent = computed(() => {
  switch (props.icon) {
    case 'lock':
      return LockIcon;
    case 'shield':
      return ShieldIcon;
    default:
      return 'div';
  }
});
</script>

<template>
  <div class="reminder">
    <div v-if="icon">
      <component :is="iconComponent" class="reminder__icon" />
    </div>
    <p class="reminder__text">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" scoped>
.reminder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4px;
  max-width: 416px;

  // &__icon {
  //  margin-inline-end: 8px;
  //  height: 20px;
  //  width: 20px;
  // }

  &__text {
    @include text-small-medium;

    text-align: center;
    padding: var(--spacing-3) var(--spacing-7);
    color: var(--colorTxtSrfTertiary);
  }
}
</style>
